import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05db50a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "col-form-label fw-bold mb-4" }
const _hoisted_3 = {
  key: 1,
  class: "d-flex justify-content-center mb-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_7 = { class: "w-max-content col-lg-3 col-form-label fw-bold" }
const _hoisted_8 = { class: "row mx-0 px-0 col-lg-4" }
const _hoisted_9 = { class: "col-lg-12" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_12 = { class: "d-flex justify-content-center" }

import { computed, onMounted, ref, watchEffect } from 'vue'
import useVuelidate from '@vuelidate/core'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'

import UploadImage from '@/components/upload-image/index.vue'
import ConfirmModal from '@/views/community-admin/community-management/components/ConfirmModal.vue'
import UpdateSuccessModal from '@/views/community-admin/community-management/components/UpdateSuccessModal.vue'
import Button from '@/components/button/index.vue'
import Breadcrumb from '@/components/breadcrumb/index.vue'
import { Modal } from 'bootstrap'

//validate
import { customMaxLength, validateMimeType } from '@/utils'
import ErrorMessage from '@/components/error-message/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'

//constant
import { translate } from '@/languages/i18n'
import { REGEX_EMOJI } from '@/constants/regex'
import { COMMUNITY_STORE } from '@/store/constants'
import { MAX_UPLOAD_FILE_SIZE_MB, MAX_UPLOAD_FILE_SIZE_BYTES } from '@/constants/number'
import commonService from '@/services/common.service'
import { debounce } from 'lodash'
import { helpers } from '@vuelidate/validators'
import { EDITOR_ACCEPTED_FILE_EXTENSION } from '@/views/community-admin/community-site/constants'

type IMG = { file: string; imgPreview: string; imgData: any }

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()

const isCheckedNgWord = {
  community_site_header_text: false,
}

const serverError = ref<boolean>(false)
const ngWordCommunitySiteHeaderText = ref<boolean>(false)

const checkNgWordCommunitySiteHeaderText = debounce(async () => {
  const queryData = { sentence: v$.value.community_site_header_text.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngWordCommunitySiteHeaderText.value = data.data?.data?.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNgWord.community_site_header_text = true
  }
}, 200)

const data = computed(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])

const modalEditConfirm = ref()

onMounted(async () => {
  await store.dispatch(COMMUNITY_STORE.ACTIONS.SET_COMMUNITY_INFO, router.currentRoute.value.params?.id)
  modalEditConfirm.value = new Modal(document.getElementById('modalConfirmCommunitySetting'))
  if (!data.value.community_site_available) {
    router.replace({ path: '/404' })
  }
})

const headerImage = ref<IMG>({ file: '', imgPreview: '', imgData: '' })

const setHeaderImage = (file: string, imgPreview: string, imgData: any): void => {
  headerImage.value = { file, imgPreview, imgData }
}

const setModelImage = (type: string, value: string) => {
  v$.value[type].$model = value
}

const showMessageError = (status: boolean): void => {
  serverError.value = status
}
const rules = computed(() => {
  return {
    community_site_header_text: {
      maxString: (value: string) => customMaxLength(value, 30),
      pictograms: function (value) {
        if (!value) {
          return true
        }
        return REGEX_EMOJI.test(value)
      },
    },
    community_site_image_url: {
      checkTypeImage: helpers.withAsync(async (value) => {
        if (!value) {
          return true
        }

        // List of allowed MIME types
        const allowedMimeTypes = ['image/png', 'image/jpeg', 'image/jpg']
        // Check the actual MIME type of the file
        return await validateMimeType(value, allowedMimeTypes)
      }),
      checkFileExtension: (value) => {
        if (!value) {
          return true
        }
        return EDITOR_ACCEPTED_FILE_EXTENSION.includes(value?.type ?? '')
      },
      fileSizeValidation: function (value) {
        if (value) {
          return value.size <= MAX_UPLOAD_FILE_SIZE_BYTES
        }
        return true
      },
    },
  }
})

const formData = ref({
  community_site_header_text: '',
})

const initImage = ref({
  community_site_image_url: '',
})

watchEffect(() => {
  formData.value = {
    community_site_header_text: data.value?.community_site_header_text || '',
  }
  initImage.value = {
    community_site_image_url: data.value?.community_site_image_url || '',
  }
})

const v$ = useVuelidate(rules, formData)
const loading = ref(false)
const onSubmit = async (): Promise<void> => {
  loading.value = true
  v$.value.$validate()
  if (v$.value.$invalid) {
    loading.value = false
    return
  }
  isCheckedNgWord.community_site_header_text = false
  await checkNgWordCommunitySiteHeaderText()
  while (!isCheckedNgWord.community_site_header_text) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (ngWordCommunitySiteHeaderText.value) {
    loading.value = false
    return
  }

  window.scroll(0, 0)
  modalEditConfirm.value.show()
  loading.value = false
}

const breadcrumb = [
  {
    content: translate('CC10home'),
    to: `/community/communities/${route.params?.id}/dashboard`,
    active: false,
  },
  {
    content: translate('communitySiteManagement'),
    to: '',
    active: false,
  },
  {
    content: translate('CL10title'),
    to: '',
    active: true,
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, { breadcrumb: breadcrumb }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CL10title')), 1),
      (serverError.value)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            title: _unref(translate)('CL10messageError')
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      (_unref(data)?.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (!_unref(data)?.loading)
        ? (_openBlock(), _createElementBlock("form", {
            key: 2,
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('communitySiteManagementHeaderText')), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "community_site_header_text",
                    class: _normalizeClass(['form-control', ngWordCommunitySiteHeaderText.value || _unref(v$).community_site_header_text.$error ? 'is-invalid' : '']),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).community_site_header_text.$model) = $event)),
                    placeholder: _unref(translate)('placeholder'),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNgWordCommunitySiteHeaderText) && _unref(checkNgWordCommunitySiteHeaderText)(...args)))
                  }, null, 42, _hoisted_10), [
                    [
                      _vModelText,
                      _unref(v$).community_site_header_text.$model,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (ngWordCommunitySiteHeaderText.value && !_unref(v$).community_site_header_text.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(InputErrorMessage, {
                    title: _unref(translate)('communitySiteManagementHeaderText'),
                    validator: _unref(v$).community_site_header_text.$errors[0]?.$validator,
                    params: [30]
                  }, null, 8, ["title", "validator"])
                ])
              ])
            ]),
            _createVNode(UploadImage, {
              title: _unref(translate)('headerLogo'),
              onSetImage: setHeaderImage,
              initImage: initImage.value?.community_site_image_url,
              type: 'community-banner',
              field: _unref(v$).community_site_image_url,
              setModelImage: (value) => setModelImage('community_site_image_url', value),
              params: [_unref(MAX_UPLOAD_FILE_SIZE_MB)],
              "msg-size": _unref(translate)('CL10ImageSize'),
              "msg-note": _unref(translate)('CL10ImageNote')
            }, null, 8, ["title", "initImage", "field", "setModelImage", "params", "msg-size", "msg-note"]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(Button, {
                title: _unref(translate)('SG40top'),
                onClick: () => _unref(router).push(`/community/communities/${_unref(route).params?.id}/dashboard`),
                type: 'secondary',
                "class-name": 'me-2'
              }, null, 8, ["title", "onClick"]),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                disabled: loading.value || _unref(v$).$invalid || ngWordCommunitySiteHeaderText.value,
                loading: loading.value,
                onClick: onSubmit
              }, null, 8, ["title", "disabled", "loading"])
            ])
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _createVNode(ConfirmModal, {
      data: { ...formData.value, ...initImage.value, headerImage: headerImage.value },
      showMessageError: showMessageError
    }, null, 8, ["data"]),
    _createVNode(UpdateSuccessModal)
  ], 64))
}
}

})